// apps/web/src/i18n/en.ts — English resource bundle.

export const enResources = {
  greeting: "Hello Gastio",
  toggle: "EN/DE",
  reservationCta: "Book a table",
  nav: {
    brand: "Gastio",
    tabHeute: "Today",
    tabReservierungen: "Reservations",
    tabKalender: "Calendar",
    tabEinstellungen: "Settings",
  },
  auth: {
    login: {
      title: "Staff Sign-in",
      subhead: "Ristorante Esempio · Management",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      loading: "Signing in…",
      roleHint: "Access depends on role: Administrator, Service, or Read-only.",
    },
    errors: {
      invalidCredentials: "Email or password is incorrect.",
      accountLocked:
        "Account temporarily locked. Please try again in 15 minutes.",
      csrfMismatch: "Session expired. Please sign in again.",
      refreshTokenReused:
        "Session ended for security reasons. Please sign in again.",
      unauthenticated: "Not signed in.",
      forbidden: "You don't have permission.",
      network: "Connection failed. Please try again.",
    },
  },
  settings: {
    placeholder: "Settings — Phase 2 placeholder",
    logout: "Sign out",
    hub: {
      title: "Settings",
      sectionReservierung: "Reservations",
      sectionBetrieb: "Operations",
      sectionBald: "Coming soon",
      rowHours: "Opening & reservation hours",
      rowAvailability: "Availability",
      rowRestaurantProfile: "Restaurant Profile",
      rowSlots: "Time slots & table duration",
      rowCapacity: "Capacity (per day & slot)",
      rowLeadTime: "Advance booking & minimum lead",
      rowSameDayCutoff: "Same-day acceptance cutoff",
      rowMinMax: "Min/Max party size",
      rowAreas: "Areas (Indoor/Terrace)",
      rowBlocked: "Blocked periods / holidays",
      rowConfirmation: "Confirmation: automatic / manual",
      rowRetention: "GDPR: retention period",
      rowUsers: "Users & roles",
      // Quick-Task 260920-u3p: hub link to the admin account page
      // (self-service email change).
      rowAccount: "Account",
      rowWaitlist: "Waitlist",
      rowStats: "Analytics (utilization, cancellation, no-show)",
      rowTables: "Table management",
      rowMultiTenant: "Multi-tenant / locations",
      tagActive: "Active",
      tagBald: "Soon",
      backToHub: "Back to settings",
    },
    restaurant: {
      nameLabel: "Restaurant name",
      slotDurationLabel: "Slot duration (minutes)",
      capacityLabel: "Default capacity (seats per day)",
      holdbackLabel: "Holdback (seats per day)",
      addressLabel: "Address",
      postalLabel: "Postal code",
      cityLabel: "City",
      phoneLabel: "Phone",
      emailLabel: "Email",
      contactNotesLabel: "Note for guests",
      taglineLabel: "Tagline (DE/EN)",
      heroCopyLabel: "Hero copy (DE/EN)",
      aboutTextLabel: "About (DE/EN)",
      save: "Save",
      cancel: "Cancel",
      saved: "Saved.",
      saveError: "Save failed.",
    },
    // Quick-Task 260920-u3p: admin self-service email-change form.
    // Keys consumed by apps/web/src/pages/admin/account.tsx. Keep
    // parity with de.ts — apps/web/src/i18n/admin-parity.test.ts
    // scans both bundles.
    account: {
      title: "Account",
      description:
        "Change the email address of your admin account. We will send a confirmation link to the new address.",
      currentEmailLabel: "Current email",
      newEmailLabel: "New email",
      newEmailPlaceholder: "your.new.address@example.com",
      submit: "Send confirmation link",
      requestSent:
        "Confirmation link was sent to {{newEmail}}. Please also check your spam folder.",
      errorSameEmail: "New email must differ from the current one.",
      errorEmailTaken:
        "This email address is already in use or is currently being verified.",
      errorRateLimited: "Too many requests — please try again in 24 hours.",
      errorGeneric: "The request could not be sent. Please try again.",
    },
    hours: {
      title: "Opening & reservation hours",
      tzLabel: "(Europe/Berlin)",
      weekdayMo: "Mon",
      weekdayTu: "Tue",
      weekdayWe: "Wed",
      weekdayTh: "Thu",
      weekdayFr: "Fri",
      weekdaySa: "Sat",
      weekdaySu: "Sun",
      closed: "Closed (regular day off)",
      ruhetag: "Regular day off",
      addException: "+ Add manual day exception",
      exceptionTitle: "Add exception",
      exceptionEditTitle: "Edit exception",
      exceptionDate: "Date",
      exceptionStatusClosed: "Closed day",
      exceptionStatusCustom: "Different hours",
      exceptionTimeRange: "{{openTime}} – {{closeTime}}{{nextDay}}",
      exceptionOpen: "Opening time",
      exceptionClose: "Closing time",
      exceptionCloseNextDay: "Closes next day",
      exceptionSave: "Save",
      exceptionCancel: "Cancel",
      exceptionEdit: "Edit exception",
      exceptionDelete: "Delete exception",
      exceptionDeleteConfirm: "Delete the exception on {{date}}?",
      exceptionLoadError: "The exception could not be loaded.",
      empty: "No exceptions defined yet.",
      saved: "Saved.",
      saveError: "Save failed.",
      preview: "Preview: {{range}} (Europe/Berlin)",
    },
    // Phase 6 quick-task 260916-bf6: per-restaurant notification
    // provider config (Brevo + SMTP) + reminder cadence + admin
    // locale. Keys mirror the German bundle so the Admin UI can be
    // translated without touching component code.
    notifications: {
      title: "Notifications",
      sectionEmail: "Email provider",
      sectionSms: "SMS provider",
      sectionReminder: "Reminder & admin language",
      save: "Save",
      saveSuccess: "Changes saved.",
      saveFailure:
        "Changes could not be saved. Please review the inputs and try again.",
      email: {
        helper:
          "Per-restaurant sender. SMTP password and Brevo API key are never returned in plain text.",
        providerSmtp: "SMTP",
        providerBrevo: "Brevo",
        host: "SMTP host",
        port: "SMTP port",
        from: "Sender address (From)",
        username: "SMTP username (optional)",
        password: "SMTP password (never displayed)",
        passwordHint:
          "Current status: {{status}} — leave blank to keep the existing password.",
        // simplify-brevo-sender-config: per-restaurant Brevo sender
        // fields are gone — sender identity is now derived from
        // Restaurant.name + Restaurant.email at send time.
        tokenSet: "configured",
        tokenMissing: "missing",
        errors: {
          hostRequired: "SMTP host must not be empty.",
          portRange: "SMTP port must be an integer between 1 and 65535.",
          fromInvalid: "Sender address must be a valid email address.",
        },
      },
      sms: {
        helper:
          "Optional HTTP webhook for SMS reminders. Token is never returned in plain text.",
        url: "Webhook URL",
        token: "Bearer token (never displayed)",
        tokenHint: "Current status: {{status}}.",
        errors: {
          urlInvalid:
            "Webhook URL must be a valid URL (or left empty to disable SMS).",
        },
      },
      reminder: {
        helper:
          "Guests receive a reminder this many hours before the reserved slot. Admin language controls the German or English version of the booking confirmation.",
        hours: "Hours before the appointment (1–168)",
        locale: "Booking email language",
        localeDe: "German",
        localeEn: "English",
        errors: {
          range: "Reminder window must be an integer between 1 and 168 hours.",
        },
      },
    },
  },
  // Phase 03 plan 03-03: admin availability surface i18n bundle.
  // Mirrors de.ts key-by-key. Parity test: apps/web/src/i18n/availability.test.ts.
  availability: {
    admin: {
      title: "Availability",
      sectionSlots: "Time slots",
      sectionCapacity: "Capacity & holdbacks",
      sectionBlockedPeriods: "Blocked periods",
      sectionBookingRules: "Booking rules",
      slot: {
        add: "Add slot",
        save: "Save slot",
        cancel: "Cancel",
        deleteArmed: "Delete the {{time}} slot? This cannot be undone.",
        deleteConfirm: "Delete slot",
        empty: "No time slots have been defined. Add the first slot.",
        weekdayMo: "Mon",
        weekdayTu: "Tue",
        weekdayWe: "Wed",
        weekdayTh: "Thu",
        weekdayFr: "Fri",
        weekdaySa: "Sat",
        weekdaySo: "Sun",
        startTime: "Start (HH:mm)",
        duration: "Duration (min)",
        active: "Active",
        weekdayBinding: "Weekdays",
        capacityOverride: "Capacity override",
        holdbackOverride: "Holdback override",
        standardOverride: "Default",
        edit: "Edit slot",
        delete: "Delete slot",
        cancelDelete: "Cancel",
      },
      capacity: {
        scopeStandard: "Default",
        scopeDate: "Date",
        scopeSlot: "Slot",
        scopeDateSlot: "Date + slot",
        columnTotal: "Total",
        columnOnline: "Online holdback",
        columnPhone: "Phone holdback",
        columnWalkIn: "Walk-in holdback",
        columnAvailable: "Available (online)",
        helper:
          "All non-cancelled reservations count against shared capacity. Holdbacks reserve seats per channel.",
        // Quick 260831-q3h: clarifies that an empty Total input means
        // "use Restaurant.capacityDefault" (= {{default}}).
        helperTotal:
          "Leave empty to fall back to the restaurant default ({{default}}).",
        save: "Save capacity",
        pickDate: "Pick a date",
        pickSlot: "Pick a slot",
        noOverride: "No override",
        defaultCapacity: "Default capacity",
      },
      blockedPeriod: {
        add: "Block period",
        allDay: "All day",
        partialDay: "Limit by time",
        fromDate: "From (date)",
        toDate: "To (date)",
        fromTime: "From (HH:mm)",
        toTime: "To (HH:mm)",
        reason: "Reason (public)",
        save: "Block period",
        cancel: "Cancel",
        deleteArmed:
          "Delete the {{range}} block? The dates will be evaluated using the remaining rules.",
        deleteConfirm: "Delete block",
        empty: "No blocked periods yet.",
        rolloverError:
          "End time must be after start time. Overnight time ranges are not supported here.",
        dateRangeError: "End date must not be before start date.",
        timeRangeError: "End time must be after start time.",
        conflictTitle:
          "There are {{count}} conflicting reservations on this day.",
        conflictAck:
          "Affected guests have been notified and reservations cancelled.",
        conflictConfirm: "Confirm block",
      },
      rules: {
        maxAdvanceDays: "Max. advance days",
        minAdvanceMinutes: "Min. lead time (minutes)",
        sameDayCutoff: "Same-day acceptance cutoff",
        minPartySize: "Min. party size",
        maxPartySize: "Max. party size",
        save: "Save booking rules",
        confirmationModeAuto: "Confirm automatically",
        confirmationModeManual: "Request manually",
        confirmationModeLabel: "Confirmation mode",
        advancedWindowHint: "Guests can book at most {{days}} days in advance.",
        sameDayCutoffHint:
          "Latest wall-clock time at which a new same-day reservation may still be submitted.",
      },
    },
    actions: {
      saveSuccess: "Changes saved.",
      saveFailure:
        "Changes could not be saved. Check the entries and try again.",
    },
    errors: {
      dayBlocked: "This day is blocked.",
      slotFull: "This slot is fully booked.",
      outsideAdvanceWindow: "Outside the booking window.",
      outsideSameDayCutoff: "Same-day cutoff already passed.",
      invalidPartySize: "Party size is outside the allowed range.",
      unexpected: "An unexpected error occurred.",
    },
    // Phase 03 plan 03-04: guest web surface (A2·B date agenda + A3 slot picker).
    // Mirrors de.ts key-by-key. Parity test: apps/web/src/i18n/availability.test.ts.
    calendar: {
      wizardMeta: "Step 1 of 6 · Date",
      heading: "Choose a date",
      prevMonth: "Previous month",
      nextMonth: "Next month",
      loading: "Loading availability",
      error: "Availability could not be loaded. Please try again.",
      retry: "Try again",
      emptyFilter: "There are no dates for this filter in this month.",
      noAvailableDates:
        "There are no available dates this month. Choose another month.",
      tabAvailable: "Available",
      tabFull: "Fully booked",
      tabBlocked: "Blocked",
      tabPast: "Past",
      tabOutsideWindow: "Outside booking window",
      rowAvailable_one: "{{count}} available time",
      rowAvailable_other: "{{count}} available times",
      rowFull: "No available times",
      rowBlocked: "Blocked · {{reason}}",
      rowBlockedNoReason: "Blocked",
      rowPast: "No longer bookable",
      rowOutsideWindow: "Outside the booking window",
    },
    slot: {
      wizardMeta: "Step 2 of 6 · Time",
      heading: "Choose a time",
      back: "Back to date selection",
      cta: "Select time",
      ctaPending: "Saving time…",
      empty: "No bookable times",
      emptyBody:
        "No bookable times are available for this date. Choose another date.",
      remaining_one: "{{count}} seat left",
      remaining_other: "{{count}} seats left",
      cutoffHint:
        "Hidden times fall outside the minimum lead time or same-day cutoff.",
      staleCleared:
        "The selected time is no longer available. Choose another time.",
    },
  },
  // Phase 03 plan 03-04: shared wizard progress segment labels (date/slot pages).
  reservation: {
    wizard: {
      step1: "Date",
      step2: "Time",
      step3: "Party",
      step4: "Contact",
      step5: "Review",
      step6: "Confirmation",
      progressAria: "Booking progress, step {{current}} of {{total}}",
    },
  },
  // Phase 5 plan 05-04 + 260801-w8s: top-level status.* / source.* keys
  // consumed by StatusTag + SourceTag in apps/web/src/pages/admin/shared/.
  // Lowercase key anchor mirrors RESERVATION_STATUS / RESERVATION_SOURCES
  // unions in packages/shared/src/index.ts so `t(\`status.${status}\`)`
  // resolves without an enum-to-key mapper. Mirrors de.ts.
  // Phase 5 plan 05-04 + 260801-w8s: top-level status.* / source.* keys
  // consumed by StatusTag + SourceTag in apps/web/src/pages/admin/shared/.
  // Keys mirror the uppercase GraphQL enum values returned by the admin API.
  status: {
    BESTAETIGT: "Confirmed",
    ANGEFRAGT: "Pending",
    ANGEKOMMEN: "Seated",
    NO_SHOW: "No show",
    STORNIERT: "Cancelled",
  },
  source: {
    ONLINE: "Online",
    TELEFON: "Phone",
    VOR_ORT: "Walk-in",
  },
  // Phase 5 admin namespace. Mirrors de.ts key-by-key. Parity test:
  // apps/web/src/i18n/admin-parity.test.ts.
  admin: {
    today: {
      pageTitle: "Today",
      layout: {
        label: "Choose view",
        list: "List",
        timeline: "Daily timeline",
      },
      bottomCta: {
        telefon: "Phone reservation",
        vorOrt: "Walk-in",
      },
      capacityBar: {
        booked: "Booked",
        holdback: "Holdback",
      },
      sortChips: {
        label: "Sort",
        time: "Time",
        name: "Name",
        party: "Party",
      },
      emptyState: {
        headline: "No reservations today",
        ctaLabel: "Create manual reservation",
      },
      // Quick 260831-q3h: trailing reservation-number annotation on
      // each timeline row (TodayTimelineView). The previous code looked
      // up a non-existent key, so the raw path leaked through the UI.
      reservationNumber: "No. {{number}}",
    },
    reservations: {
      pageTitle: "Reservations",
      header: {
        manualCreate: "Add manual",
      },
      datePicker: {
        prevDay: "Previous day",
        nextDay: "Next day",
        today: "Today",
        blockDay: "Block day",
      },
      search: {
        placeholder: "Search…",
        scopeNotice: "Search runs across all days ({{date}} is not in effect).",
        scopeReset: "Back to {{date}}",
      },
      filters: {
        title: "Filters",
        status: "Status",
        source: "Source",
        apply: "Apply",
        clear: "Reset",
      },
      empty: "No reservations found.",
      loadMore: "Load more",
      row: {
        edit: "Edit",
        cancel: "Cancel",
        // Quick 260831-q3h: inline status-transition buttons for the
        // 5-state machine (D-06 / D-07). Confirm = ANGEFRAGT →
        // BESTAETIGT. Mark-arrived + mark-no-show appear once a
        // reservation is Bestätigt (or, for no-show, after Arrived).
        confirm: "Confirm",
        markArrived: "Mark arrived",
        markNoShow: "Mark no-show",
        internalNoteLabel: "Internal note",
      },
      errors: {
        notFound: "Reservation not found.",
      },
      // Phase 6 plan 06-04 (EXP-01..03): admin-only CSV/PDF export.
      // Mirrors the DE keys above 1:1; the existing admin-i18n-parity
      // test scans both bundles and fails if any leaf is missing.
      export: {
        button: "Export",
        format: {
          csv: "CSV",
          pdf: "PDF",
        },
        fromDate: "From",
        toDate: "To",
        success: "Export is downloading…",
        error: "Export failed",
      },
    },
    reservationEdit: {
      pageTitle: "Edit reservation",
      notAuthorized: "You don't have permission to edit.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      partySize: "Party size",
      internalNote: "Internal note",
      save: "Save",
      cancel: "Cancel",
    },
    manualCreate: {
      pageTitle: "Manual reservation",
      sourceLabel: "Source",
      sourceTelefon: "Phone",
      sourceVorOrt: "Walk-in",
      dateLabel: "Date",
      timeLabel: "Time",
      partySizeLabel: "Party size",
      nameLabel: "Name",
      emailOptional: "Email (optional)",
      phoneOptional: "Phone (optional)",
      internalNoteLabel: "Internal note",
      capacityWarning: "Capacity will be exceeded.",
      cutoffWarning: "Outside the same-day cutoff.",
      forceConfirm: "Create anyway",
      submit: "Create reservation",
    },
    calendar: {
      pageTitle: "Calendar",
      monthNav: {
        prev: "Previous month",
        next: "Next month",
      },
      blockedRanges: {
        title: "Blocked periods",
        edit: "Edit",
        delete: "Delete",
        confirmDelete:
          "Delete the blocked period? The dates will be evaluated normally again.",
        empty: "No blocked periods yet.",
      },
      capacityFooter: {
        title: "Day capacity",
        booked: "Booked",
        capacity: "Capacity",
        holdback: "Holdback",
        remaining: "Available (online)",
      },
      dayTap: {
        unblockTitle: "Release day?",
        unblockConfirm: "Release",
        unblockCancel: "Cancel",
        unblockSuccess: "Day released.",
        blockTitle: "Block day",
        blockSuccess: "Day blocked.",
        errorFallback: "An unexpected error occurred.",
      },
    },
  },
  // Phase 4 plan 04-03: guest wizard A4..A7 (slot picker, contact,
  // consent, review, submit, confirmation). Mirrors de.ts.
  wizard: {
    a4: {
      title: "Choose a date",
      subtitle: "Choose an available time",
      back: "Back",
      next: "Continue",
      meta: "Step 4 of 6 · Time slot",
      empty: "No available times for this date",
      retry: "Try again",
      errorMessage: "The times could not be loaded. Please try again.",
      loading: "Loading available times",
      tooltip: {
        blocked: "Reservations currently unavailable",
        full: "Time slot fully booked",
        outsideBookingHours: "Outside opening hours",
      },
      errors: {
        empty: "Please choose a time",
        invalid: "Time slot invalid",
      },
    },
    a5: {
      title: "Your contact details",
      subtitle: "We need your name and at least one contact method",
      nameLabel: "Full name",
      emailLabel: "Email",
      phoneLabel: "Phone",
      consentLabel: "I consent to the processing of my data",
      back: "Back",
      next: "Continue",
      errors: {
        nameRequired: "Please enter your name",
        nameTooLong: "Name may not exceed 120 characters",
        emailInvalid: "Please enter a valid email",
        phoneInvalid: "Please enter a valid phone number",
        contactRequired: "Please enter at least one email or phone number",
        consentRequired: "Please consent to data processing",
        consentEmpty: "Privacy text unavailable",
      },
    },
    a6: {
      title: "Review your reservation",
      subtitle: "Please review all details before confirming",
      back: "Back",
      submit: "Confirm reservation",
      submitManual: "Send request",
      manualNote:
        "Your request will be confirmed by the restaurant. You will receive a confirmation by email.",
      submitting: "Submitting…",
      summary: {
        date: "Date",
        time: "Time",
        duration: "Duration",
        party: "Party",
        contact: "Contact",
        consent: "Privacy notice",
      },
      errors: {
        invalidDate: "Date invalid",
        invalidSlot: "Slot invalid",
        partySize: "Party size invalid",
        invalidArea: "Area invalid",
      },
    },
    a7: {
      title: "Reservation confirmed",
      titleManual: "Request received",
      reservationNumberLabel: "Confirmation number",
      selfServiceLabel: "Self-service link",
      copyLink: "Copy link",
      linkCopied: "Copied",
      tokenExpiresAt: "Valid until {{date}}",
      tokenExpiresCaption:
        "The link is valid for 24 hours. Keep it safe to view, modify, or cancel your reservation later.",
      fallbackTitle: "This page is only reachable directly after a reservation",
      fallbackBody: "Please use the link in your confirmation email.",
      nextActions: "What would you like to do next?",
      manageAction: "Manage reservation",
      newAction: "New reservation",
      home: "Back to home",
      partySize_one: "{{count}} person",
      partySize_other: "{{count}} people",
      dateTime: "{{date}} at {{time}}",
    },
    // Phase 4 plan 04-04: self-service surface (A8 read view).
    a8: {
      title: "Your reservation",
      subtitle: "Here you can view, modify, or cancel your reservation",
      status: {
        label: "Status",
        confirmed: "Confirmed",
        requested: "Request received",
        cancelled: "Cancelled",
        noShow: "No show",
      },
      confirmationMode: {
        label: "Confirmation mode",
        auto: "Automatically confirmed",
        manual: "Awaiting confirmation",
      },
      actions: {
        modify: "Modify reservation",
        cancel: "Cancel reservation",
      },
      disabledReason:
        "Modifications and cancellations are only possible up to 60 minutes before the appointment.",
      tokenInvalid:
        "This link is no longer valid. Please contact the restaurant to manage your reservation.",
      loading: "Loading reservation…",
      footer:
        "This page is only accessible via the link in your confirmation email.",
    },
    // Phase 4 plan 04-04: A9 modify + A10 cancel + A11 cancelled.
    a9: {
      title: "Modify reservation",
      subtitle: "Choose a new time",
      step1: "New time",
      step2: "Name",
      back: "Back",
      next: "Continue",
      submit: "Confirm changes",
      submitting: "Submitting…",
      success: "Your reservation has been updated.",
      errorExpired: "This reservation can no longer be modified or cancelled.",
      errorNameRequired: "Please enter your name",
      errorNameTooLong: "Name may not exceed 120 characters",
    },
    a10: {
      title: "Cancel reservation",
      subtitle: "Do you really want to cancel your reservation?",
      reasonLabel: "Optional: Reason for cancellation",
      confirmLabel: "Yes, I want to cancel",
      submit: "Confirm cancellation",
      submitting: "Submitting…",
      errorConfirmRequired:
        "Please confirm the cancellation by ticking the checkbox.",
    },
    a11: {
      title: "Your reservation has been cancelled",
      body: "You will receive a confirmation by email shortly.",
      newAction: "New reservation",
    },
    // Phase 4 follow-up #2: mirror of `de.ts#wizard.notFound`.
    notFound: {
      title: "Page not found",
      body: "The requested link does not exist. If you want to manage a reservation, open the link from your confirmation email.",
      home: "Back to home",
    },
  },
  // Phase 4 plan 04-03: server-error message keys. Mirrors de.ts.
  errors: {
    slotFull:
      "This time slot is unfortunately fully booked. Please choose another.",
    turnstileFailed: "Security check failed. Please try again.",
    reservationExpired:
      "This reservation can no longer be modified or cancelled.",
    noContactMethod: "Please enter at least one email or phone number",
    areaDisabled: "Area currently not offered",
    outsideAdvanceWindow: "Date is outside the booking window",
    outsideSameDayCutoff:
      "Reservations for today are no longer possible. Please choose another date.",
    outsideSameDayCutoffSelfService:
      "The selected time is outside the booking window.",
    network: "Connection failed. Please try again.",
    invalidInput: "Please check your input.",
  },
  // Phase 7 plan 07-06: self-service signup + onboarding wizard
  // strings. The DE/EN bundles must keep parity — see
  // apps/web/test/signup.test.tsx (i18n parity assertion).
  signup: {
    title: "Register your restaurant",
    subtitle: "Create your own Gastio tenant account in just a few minutes.",
    slug: "Desired slug (e.g. acme-bistro)",
    slugHint:
      "Becomes part of your subdomain ({{slug}}.{{baseDomain}}). Lowercase letters, digits, and dashes, 3–40 chars.",
    restaurantName: "Restaurant name",
    email: "Email",
    address: "Address",
    postalCode: "Postal code",
    city: "City",
    consent: "I consent to my data being processed for account creation.",
    submit: "Request registration",
    submitting: "Sending…",
    checkEmail:
      "We sent a confirmation link to {{email}}. Please click it within 24 hours.",
    slugSuggestions: "Suggestions",
    invalidInput:
      "Please review your input — the slug must be 3–40 characters and contain only lowercase letters, digits, and dashes.",
    slugTaken:
      "This slug is already taken. Choose another or pick one of the suggestions.",
    genericError: "Registration failed. Please try again.",
    adminPassword: "Administrator password",
    adminPasswordHint: "At least 12 characters.",
    adminPasswordConfirm: "Repeat password",
    adminPasswordMismatch: "Passwords do not match.",
    adminPasswordTooShort: "Password must be at least 12 characters long.",
  },
  onboarding: {
    brand: "Onboarding",
    back: "Back",
    progressAria: "Onboarding progress, step {{current}} of {{total}}",
    step: {
      address: "Address",
      capacity: "Capacity",
      hours: "Hours",
      review: "Review",
    },
    addressTitle: "Your address",
    addressStreet: "Street and house number",
    addressPostalCode: "Postal code",
    addressCity: "City",
    capacityTitle: "Your default capacity",
    capacityTotalSeats: "Seats per day",
    capacityHelp: "How many seats do you have available per day in total?",
    hoursTitle: "Your opening hours",
    hoursHelp:
      "Enter opening hours for each weekday. Leave a day blank to mark it closed.",
    reviewTitle: "Please review and confirm",
    reviewSummary: "Summary",
    adminPasswordHint:
      "Set the password you will use to sign in to the admin area.",
    submitting: "Saving…",
    saveNext: "Save & continue",
    activate: "Activate restaurant",
    activated:
      "Restaurant activated — you will be redirected to the sign-in page.",
    requiredField: "Required field",
    hoursInvalid: "Invalid time (HH:mm).",
  },
  // Quick-Task 260920-u3p: public confirm-email-change deeplink
  // page (apps/web/src/pages/confirm-email-change/[token].tsx). The
  // page fires the mutation on mount, so the strings are the three
  // terminal states (pending / success / error).
  accountConfirm: {
    title: "Confirming email address",
    pending: "Confirmation is being processed. One moment please …",
    successTitle: "Email address updated",
    successBody:
      "Your admin email address is now {{email}}. For security, all active sessions have been ended.",
    successHint: "Please sign in again with your new email address.",
    continue: "Continue to sign-in",
    errorTitle: "Confirmation not possible",
    errorBody:
      "The confirmation link is invalid, expired, or has already been used. Please request a new link.",
    errorRateLimitTitle: "Too many requests",
    errorRateLimitBody:
      "You have made too many requests in the last 24 hours. Please try again later.",
    backToLogin: "Back to sign-in",
  },
} as const;
